import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Configuración de Firebase desde variables de entorno (.env.local)
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Inicializar Firebase solo si no está ya inicializado
let app;
if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
} else {
    app = getApps()[0];
}

// Inicializar servicios de Firebase
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Solo conectar emuladores en desarrollo si no están ya conectados
if (process.env.NODE_ENV === 'development') {
    try {
        // Comentado temporalmente para usar Firebase real en lugar de emuladores
        // if (typeof (auth as any)._delegate._config?.emulator === 'undefined') {
        //     connectAuthEmulator(auth, "http://localhost:9099");
        // }
        // if (!(db as any)._delegate._databaseId.projectId.includes('demo-')) {
        //     connectFirestoreEmulator(db, 'localhost', 8080);
        // }
    } catch (error) {
        // Emuladores ya conectados o no disponibles
        console.log('Firebase emulators already connected or not available');
    }
}

export default app; 